/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Объект для представления запроса на обновление существующего перевода
 */
export interface TransferUpdateRequest {
  /** ИД счёта с которого будет производится перевод */
  accountId?: string;

  /** сумма перевода */
  amount?: string;

  /** ИД клиента */
  clientId?: string;

  /** ИД перевода */
  id?: string;

  /** номер счёта на который будет осуществляться перевод */
  accountNumber?: string;

  /** тип перевода */
  type?:
    | "OTHER"
    | "ACCOUNT_TO_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_MYSELF_CARD"
    | "ACCOUNT_TO_SALARY_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_SERVICE_PHYSICAL_PERSON_CARD"
    | "DIVIDENDS"
    | "LOAN"
    | "AMOUNT_FOR_REPORT";

  /** НДС в процентах */
  vatPercent?: string;

  /** номер карты на которую будет осуществляться перевод */
  cardNumber?: string;

  /** назначение перевода */
  purposeTransfer?: string;
}

export interface ValidationErrorInfo {
  /** Код ошибки */
  errorCode: "VALIDATION_ERROR" | "SECURITY_ERROR";

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /**
   * Дата и время генерации ошибки
   * @format date-time
   */
  timestamp: string;

  /** Развернутое описание ошибки/ок */
  errorDetails: Record<string, ValidationFieldInfo[]>;
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;

  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;
}

/**
 * список доступных действий с переводом
 */
export interface DocumentAction {
  /** Признак доступности действия */
  isAvailable: boolean;

  /** Наименование действия */
  name: string;

  /** Описание действия */
  desc: string;
}

/**
 * Объект для представления ответа по запросу на сохранение/перезапись перевода
 */
export interface TransferSaveResponse {
  /** список доступных действий с переводом */
  availableActions?: DocumentAction[];

  /**
   * номер перевода
   * @format int64
   */
  number?: number;

  /** ИД перевода */
  id?: string;

  /** статус перевода */
  status?: string;
}

/**
 * Объект для представления запроса на сохранение перевода
 */
export interface TransferSaveRequest {
  /**
   * ИД счёта отправителя
   * @pattern ^\d+$
   */
  accountId: string;

  /** сумма перевода */
  amount: number;

  /** ИД клиента */
  clientId: string;

  /** Номер счёта с которого будет производится перевод */
  accountPayerNumber: string;

  /** БИК банка получателя */
  bicPayee: string;

  /** тип перевода */
  type:
    | "OTHER"
    | "ACCOUNT_TO_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_MYSELF_CARD"
    | "ACCOUNT_TO_SALARY_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_SERVICE_PHYSICAL_PERSON_CARD"
    | "DIVIDENDS"
    | "LOAN"
    | "AMOUNT_FOR_REPORT";

  /**
   * НДС в процентах
   * @pattern ^\d{1,2}$
   */
  vatPercent?: string;

  /**
   * Номер карты на которую будет осуществляться перевод
   * @pattern ^\d+$
   */
  cardNumber: string;

  /**
   * Номер счёта на который будет осуществляться перевод
   * @pattern ^\d+$
   */
  accountPayeeNumber: string;

  /** назначение перевода */
  purposeTransfer: string;

  /** БИК банка отправителя */
  bicPayer: string;
}

/**
 * Объект для представления запроса получение PDF
 */
export interface ExtractRequest {
  /**
   * ИД трансфера для PDF
   * @format uuid
   */
  transferId: string;
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * Объект для представления запроса на сохранение пополнения
 */
export interface ReplenishmentSaveRequest {
  /** CVV код */
  cardCvv?: string;

  /** ИД счёта с которого будет производится перевод */
  accountId: string;

  /** сумма перевода */
  amount: number;

  /** ИД клиента */
  clientId: string;

  /** срок действия карты */
  cardExpirationDate?: string;

  /**
   * Номер счёта на который будет осуществляться перевод
   * @pattern ^\d+$
   */
  accountNumber: string;

  /**
   * номер карты с который будет осуществляться пополнение
   * @pattern ^\d+$
   */
  cardNumber: string;
}

/**
 * Объект для представления ответа по запросу на сохранение/перезапись пополнения
 */
export interface ReplenishmentSaveResponse {
  /** список доступных действий с переводом */
  availableActions?: string[];

  /**
   * номер пополнения
   * @format int64
   */
  number?: number;

  /** ИД пополнения */
  id?: string;
}

/**
 * Объект для представления ответа по запросу на предоставление информации по переводу
 */
export interface TransferResponse {
  /** список доступных действий с переводом */
  availableActions?: DocumentAction[];

  /**
   * дата перевода
   * @format date
   */
  date?: string;

  /** сумма перевода */
  amount?: string;

  /** БИК получателя */
  bicPayee?: string;

  /** тип перевода */
  type?:
    | "OTHER"
    | "ACCOUNT_TO_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_MYSELF_CARD"
    | "ACCOUNT_TO_SALARY_PHYSICAL_PERSON_CARD"
    | "ACCOUNT_TO_SERVICE_PHYSICAL_PERSON_CARD"
    | "DIVIDENDS"
    | "LOAN"
    | "AMOUNT_FOR_REPORT";

  /** НДС в процентах */
  vatPercent?: string;

  /** назначение перевода */
  purposeTransfer?: string;

  /**
   * номер перевода
   * @format int64
   */
  number?: number;

  /** ИД счёта с которого будет производится перевод */
  accountId?: string;

  /** номер счёта с которого будет осуществляться перевод */
  accountPayerNumber?: string;

  /** ИД перевода */
  id?: string;

  /** номер счёта на который будет осуществляться перевод */
  accountPayeeNumber?: string;

  /** номер карты на которую будет осуществляться перевод */
  cardNumber?: string;

  /** статус перевода */
  status?: string;

  /** БИК отправителя */
  bicPayer?: string;
}

/**
 * Объект для представления ответа по запросу на предоставление информации по пополнению
 */
export interface ReplenishmentResponse {
  /**
   * дата пополнения
   * @format date
   */
  date?: string;

  /**
   * номер пополнения
   * @format int64
   */
  number?: number;

  /** ИД счёта с которого будет производится перевод */
  accountId?: string;

  /** сумма пополнения */
  amount?: string;

  /** ИД пополнения */
  id?: string;

  /** ИД счёта на который будет осуществляться пополнение */
  accountNumber?: string;

  /** номер карты с который будет осуществляться пополнение */
  cardNumber?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис transfers
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://transfers.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Переводы
     * @name GetAllTransfers
     * @summary Получение списка переводов
     * @request GET:/api/transfers/v1/transfer
     * @secure
     */
    getAllTransfers: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<TransferResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name UpdateTransfer
     * @summary Обновление перевода
     * @request PUT:/api/transfers/v1/transfer
     * @secure
     */
    updateTransfer: (data: TransferUpdateRequest, params: RequestParams = {}) =>
      this.request<TransferSaveResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name CreateTransfer
     * @summary Создание перевода
     * @request POST:/api/transfers/v1/transfer
     * @secure
     */
    createTransfer: (data: TransferSaveRequest, params: RequestParams = {}) =>
      this.request<TransferSaveResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name Report
     * @summary Получение печатной формы в PDF
     * @request POST:/api/transfers/v1/transfer/report
     * @secure
     */
    report: (data: ExtractRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer/report`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пополнения
     * @name GetAllReplenishments
     * @summary Получение списка пополнений
     * @request GET:/api/transfers/v1/replenishment
     * @secure
     */
    getAllReplenishments: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<ReplenishmentResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/replenishment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пополнения
     * @name CreateReplenishment
     * @summary Создание пополнения
     * @request POST:/api/transfers/v1/replenishment
     * @secure
     */
    createReplenishment: (
      data: ReplenishmentSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<ReplenishmentSaveResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/replenishment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name GetTransferById
     * @summary Получить перевод по идентификатору
     * @request GET:/api/transfers/v1/transfer/{id}
     * @secure
     */
    getTransferById: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<TransferResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name DeleteTransfer
     * @summary Удаление перевода
     * @request DELETE:/api/transfers/v1/transfer/{id}
     * @secure
     */
    deleteTransfer: (
      id: string,
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name GetLastThreeTransfers
     * @summary Получение 3 последних трансфера
     * @request GET:/api/transfers/v1/transfer/last
     * @secure
     */
    getLastThreeTransfers: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<TransferResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer/last`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Переводы
     * @name HideTransfer
     * @summary Скрытие трансфера из истории
     * @request GET:/api/transfers/v1/transfer/hide
     * @secure
     */
    hideTransfer: (query: { id: string }, params: RequestParams = {}) =>
      this.request<EmptyResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/transfer/hide`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пополнения
     * @name GetLastThreeReplenishments
     * @summary Получение 3 последних пополнений
     * @request GET:/api/transfers/v1/replenishment/last
     * @secure
     */
    getLastThreeReplenishments: (
      query: { clientId: number },
      params: RequestParams = {}
    ) =>
      this.request<ReplenishmentResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/replenishment/last`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Пополнения
     * @name HideReplenishment
     * @summary Скрытие пополнения из истории
     * @request GET:/api/transfers/v1/replenishment/hide
     * @secure
     */
    hideReplenishment: (query: { id: string }, params: RequestParams = {}) =>
      this.request<EmptyResponse, ValidationErrorInfo>({
        path: `/api/transfers/v1/replenishment/hide`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Аккаунт
     * @name GetAllAccounts
     * @summary Получение списка аккаунтов
     * @request GET:/api/transfers/v1/account
     * @secure
     */
    getAllAccounts: (query: { clientId: number }, params: RequestParams = {}) =>
      this.request<string, ValidationErrorInfo>({
        path: `/api/transfers/v1/account`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Аккаунт
     * @name GetAllFilials
     * @summary Получение списка филиалов
     * @request GET:/api/transfers/v1/account/filials
     * @secure
     */
    getAllFilials: (params: RequestParams = {}) =>
      this.request<string, ValidationErrorInfo>({
        path: `/api/transfers/v1/account/filials`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Аккаунт
     * @name GetAllBanks
     * @summary Получение списка банков
     * @request GET:/api/transfers/v1/account/banks
     * @secure
     */
    getAllBanks: (params: RequestParams = {}) =>
      this.request<string, ValidationErrorInfo>({
        path: `/api/transfers/v1/account/banks`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
